import { Link } from 'react-router-dom';
import { Sparkle } from '@/components/ornaments';
import { TOUR_HUB_PATH, type TourEvent } from '@/features/events';
import { cx } from '@/lib/cx';
import styles from './MigaGira.module.css';

/* =============================================================================
 * MIGA DE PAN «✦ La gira · <ciudad>» — VERSIÓN SOBRE LA FOTO
 * -----------------------------------------------------------------------------
 * ENCARGO DEL CLIENTE (25-ago-2026, por WhatsApp): «arriba a la izquierda donde
 * pone LA GIRA - BUENOS AIRES. Falta poner lo mismo en México y Cancún. Para
 * que puedan volver al inicio cuando hagan clic en LA GIRA».
 *
 * POR QUÉ NO SE REUSA `MigaGiraBogota` NI `BaMiga`: aquéllas van EN FLUJO, en
 * una tira de crema entre la cabecera y el hero. En `/mexico` y `/cancun` el
 * hero se come el `padding-block-start` que `Page.main` reserva para la cabecera
 * fija (margen negativo de `--az-header-height`) para que la foto llegue a y=0,
 * que es la composición que el cliente aprobó. Una tira en flujo ahí o rompe esa
 * composición o queda tapada por el propio hero. Ésta vive DENTRO de la celda
 * del hero, anclada arriba-izquierda — el mismo sitio y el mismo z-index que el
 * medallón de `/miami`.
 *
 * Y POR QUÉ LLEVA CHAPA DE CREMA: FINDING-004 prohíbe fiar el contraste de un
 * texto al encuadre de una foto. La chapa opaca es la que sostiene el ratio,
 * igual que en `.badgeMedal` de `/miami` (PAGE_CONTRACT §3.3.bis). Bajar su
 * opacidad es bajar el contraste.
 *
 * A diferencia de la miga de `/bogota`, ésta NO se esconde de 1024 arriba: el
 * cliente la pidió mirando su escritorio, y la referencia que dio —Buenos
 * Aires— la enseña a todos los anchos.
 * ========================================================================== */
export interface MigaGiraProps {
  event: TourEvent;
  /** Clase de POSICIÓN, que la pone la página (la celda del hero es suya). */
  className?: string;
}

export function MigaGira({ event, className }: MigaGiraProps) {
  return (
    <nav className={cx(styles.miga, className)} aria-label="Migas de navegación">
      <ol className={styles.lista}>
        <li>
          <Link className={styles.enlace} to={TOUR_HUB_PATH}>
            <span className={styles.destello} aria-hidden="true">
              <Sparkle size={12} variant="line" />
            </span>
            La gira
          </Link>
        </li>
        <li aria-hidden="true" className={styles.punto}>
          ·
        </li>
        {/* `aria-current="page"` y NO un enlace: la página actual no se enlaza a
            sí misma. */}
        <li className={styles.actual} aria-current="page">
          {event.shortName}
        </li>
      </ol>
    </nav>
  );
}
